/**
 * @file スタイル設定：ブレイクポイント 定数管理
 */

export const breakpoint = {
    sp: "600px",
    spWide: "768px",
    tablet: "950px",
    pc: "1200px",
};
